/* KLS retention & recovery: cart upsell + email-gated exit-intent popup. Native Minimog hooks, no app. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var v = cents / 100;
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(v); }
    catch (e) { return '₹' + Math.round(v); }
  }
  function thumb(url) { return url ? url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2') : ''; }

  /* ---------------- CART UPSELL ---------------- */
  var rendering = false;
  function recUrl(seed, intent) { return root + 'recommendations/products.json?product_id=' + seed + '&limit=10&intent=' + intent; }
  function fetchRecs(seed) {
    // prefer curated complementary products; gracefully fall back to related
    return fetch(recUrl(seed, 'complementary'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = (d && d.products) || [];
        if (p.length) return p;
        return fetch(recUrl(seed, 'related'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d2) { return (d2 && d2.products) || []; });
      })
      .catch(function () { return []; });
  }
  function cardHTML(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    var price = money(v ? v.price : p.price);
    var url = root.replace(/\/$/, '') + p.url;
    return '<div class="kls-cu__item">' +
      '<a class="kls-cu__imgwrap" href="' + url + '"><img class="kls-cu__img" src="' + thumb(p.featured_image || (p.images && p.images[0]) || '') + '" alt="" loading="lazy" width="56" height="56"></a>' +
      '<div class="kls-cu__info"><a class="kls-cu__title" href="' + url + '">' + p.title + '</a><span class="kls-cu__price">' + price + '</span></div>' +
      '<button type="button" class="kls-cu__add" data-kls-add data-vid="' + (v ? v.id : '') + '"' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? 'Add' : 'Sold out') + '</button>' +
      '</div>';
  }
  function renderCartUpsell() {
    var containers = document.querySelectorAll('[data-kls-cart-upsell]');
    if (!containers.length || rendering) return;
    rendering = true;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        containers.forEach(function (c) { c.setAttribute('hidden', ''); });
        if (!cart || !cart.items || !cart.items.length) { rendering = false; return; }
        var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
        var seed = cart.items[cart.items.length - 1].product_id;
        return fetchRecs(seed)
          .then(function (products) {
            var recs = (products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
            if (!recs.length) { rendering = false; return; }
            containers.forEach(function (c) {
              var list = c.querySelector('.kls-cu__list');
              if (!list) return;
              list.innerHTML = recs.map(cardHTML).join('');
              c.removeAttribute('hidden');
              list.querySelectorAll('[data-kls-add]').forEach(function (b) { b.addEventListener('click', onAdd); });
            });
            rendering = false;
          });
      })
      .catch(function () { rendering = false; });
  }
  function onAdd(e) {
    var btn = e.currentTarget, vid = btn.getAttribute('data-vid');
    if (!vid) return;
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function () {
        // let Minimog's native handler re-fetch sections, count and drawer
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        setTimeout(renderCartUpsell, 500);
      })
      .catch(function () { btn.disabled = false; btn.textContent = old; });
  }

  /* ---------------- EXIT-INTENT POPUP ---------------- */
  var KEY = 'kls_exit_popup_v2';
  function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) { } }
  var armed = false, shownThisLoad = false;
  function show() {
    if (seen() || shownThisLoad) return;
    var el = document.getElementById('kls-exit-popup');
    if (!el) return;
    shownThisLoad = true;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
  }
  function hide() {
    var el = document.getElementById('kls-exit-popup');
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
    mark();
  }
  function reveal() {
    var el = document.getElementById('kls-exit-popup');
    if (!el) return;
    el.querySelector('[data-kls-stage="form"]').hidden = true;
    el.querySelector('[data-kls-stage="success"]').hidden = false;
  }
  function initPopup() {
    var el = document.getElementById('kls-exit-popup');
    if (!el) return;
    el.querySelectorAll('[data-kls-close]').forEach(function (b) { b.addEventListener('click', hide); });
    var form = el.querySelector('form[data-kls-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var email = input ? input.value.trim() : '';
      if (!email) { if (input) input.focus(); return; }
      var body = new URLSearchParams();
      body.append('form_type', 'customer'); body.append('utf8', '✓');
      body.append('contact[tags]', 'newsletter,exit-popup');
      body.append('contact[email]', email);
      fetch(root + 'contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' }, body: body.toString() })
        .catch(function () { }).finally(function () { reveal(); mark(); });
    });
    var copy = el.querySelector('[data-kls-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = copy.getAttribute('data-code') || 'STAY10';
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      var t = copy.textContent; copy.textContent = 'Copied!';
      setTimeout(function () { copy.textContent = t; }, 1600);
    });
    // desktop exit intent
    document.addEventListener('mouseout', function (e) {
      if (!armed) return;
      if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) show();
    });
    // arm after a short delay so it doesn't fire instantly
    setTimeout(function () { armed = true; }, 4000);
    // mobile fallback: show after 35s of engagement
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      setTimeout(function () { show(); }, 35000);
    }
  }

  function init() {
    renderCartUpsell();
    document.addEventListener('cart:updated', function () { setTimeout(renderCartUpsell, 150); });
    document.addEventListener('cart:refresh', function () { setTimeout(renderCartUpsell, 300); });
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
